export const LOGOUT_URL = '/.auth/logout';

export function loginUrl() {
  const destination = `${window.location.pathname}${window.location.search}` || '/';
  return `/.auth/login/aad?post_login_redirect_uri=${encodeURIComponent(destination)}`;
}

export async function getSignedInUser() {
  try {
    const response = await fetch('/.auth/me');
    const payload = await response.json();
    return payload.clientPrincipal || null;
  } catch (error) {
    console.error('Could not read signed-in user:', error);
    return null;
  }
}
